/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Project Properties that are used for filtering.
 *
 */
export var FaultPropertiesForFiltering;
(function (FaultPropertiesForFiltering) {
    FaultPropertiesForFiltering["FAULT_REPORTED_TIME"] = "faultReportedTime";
})(FaultPropertiesForFiltering || (FaultPropertiesForFiltering = {}));
